import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/hitechvn/web-user/src/components/projects/detail/Index.jsx");
